/** @format */

export const sortDatesDescending = (a: string, b: string) => new Date(b).getTime() - new Date(a).getTime();
